import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { models } from '../modele/modele-form';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';
import { SubscriptionService } from 'src/app/services/subscription.service';

import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-stock-marchandises',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss']
})
export class StockMarchandisesComponent implements OnInit {

  // Navigation et état
  currentStep = 0;
  totalSteps = 4; // accueil + 2 étapes + récapitulatif
  
  // Formulaire principal
  simulationStockForm: FormGroup;
  
  // États de l'interface
  loader: boolean = false;
  sendingRequest: boolean = false;
  isFocus: boolean = false;
  hasPhoneError: boolean = false;
  
  // Données
  listTypeSexe = [{name:'Féminin',value:'Feminin'},{name:'Masculin',value:'Masculin'}];
  listDuree = [
    { name: '1 mois', value: '1' }, 
    { name: '3 mois', value: '3' },
    { name: '6 mois', value: '6' }, 
    { name: '1 an', value: '12' },
    { name: '1 an - 3 mois', value: '15' }, 
    { name: '1 an 6 mois', value: '18' },
    { name: '2 ans', value: '24' }
  ];
  
  // Configuration
  newDate = new Date();
  minDateEffet = new Date();
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  // Références
  numeroSous: string;
  refPro: string;
  
  // Informations de la page
  slideData;
  lien = "";
  informations;
  title = "";

  // Document médical
  nomFile: string = "";
  noImage: string = "assets/images/upload.png";
  pieceJointe: FormGroup;
  downloadIcon = "assets/fileDownload/file.png";
  downloadFile: boolean = true;
  typeProduitList: any = {
    questionnaireUrl: '/assets/fileDownload/questionnaire_default.pdf'
  };
  currentFiliale = JSON.parse(localStorage.getItem('currentFiliale'));

    // ===== AJOUT POUR AUTOSAVE =====
  private autoSaveSubject$ = new Subject<any>();
  private autoSaveSubscription: Subscription;
  private lastSavedData: string = ''; // Pour comparer les données
  // ================================


  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private utilsService: UtilsService,
    private rechercheService: SubscriptionService
  ) {
    // Initialisation des références
    let time = new Date().getTime();
    let pro = new Date().getTime() + 123890989;
    this.numeroSous = "SM" + time + "SC";
    this.refPro = "SM" + pro + "PR";

    // @ts-ignore
    let lienBrute: String = this.route.snapshot._routerState.url;
    this.lien = lienBrute.substring(1, lienBrute.length);
    this.informations = models[this.lien];
        
    localStorage.setItem('sectionShown', this.lien);
    this.slideData = [{
      title: this.informations.title,
      subTitle: this.informations.subTitle,
      description: this.informations.description,
      img: this.informations.imgBackground,
      type: this.informations.type,
      imgIcon: this.informations.imgIcon
    }]; 
  }

  ngOnInit() {
    this.initializeForm();
    this.setupAutoSave();
  }

  // Initialisation du formulaire selon le modèle stock de marchandises
  initializeForm() {
    this.simulationStockForm = this.fb.group({
      // Étape 1: Informations sur le stock
      email: new FormControl('', [Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])]),
      telephone: ['', Validators.required],
      adresse: ['', Validators.required], // Localisation du magasin
      ville: ['', Validators.required],
      dateEffet: ['', Validators.required],
      duree: ['', Validators.required],
      valeurStock: ['', Validators.required],
      typeMarchandises: ['', Validators.required],
      
      // Étape 2: Informations de l'entreprise
      nom: ['', Validators.required], // Nom de l'entreprise
      dateNaiss: ['', Validators.required],
      sexe: ['', Validators.required]
    });

    // FormGroup séparé pour le document médical
    this.pieceJointe = new FormGroup({
      file: new FormControl('')
    });
  }

  // Navigation entre les étapes
  nextStep() {
    if (this.currentStep === 0) {
      // Depuis la page d'accueil, on va directement à l'étape 1
      this.currentStep = 1;
      setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      return;
    }
    
    if (this.isCurrentStepValid()) {
      if (this.currentStep < 3) {
        this.currentStep++;
        setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      }
    } else {
      this.markFormGroupTouched();
      this.toastr.warning("Veuillez remplir tous les champs obligatoires", "Attention");
    }
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      window.scrollTo(0, 0);
    }
  }

  // Validation des étapes
  isCurrentStepValid(): boolean {
    switch (this.currentStep) {
      case 1: // Informations sur le stock
        return this.simulationStockForm.get('telephone')?.valid && 
               this.simulationStockForm.get('adresse')?.valid &&
               this.simulationStockForm.get('ville')?.valid &&
               this.simulationStockForm.get('dateEffet')?.valid &&
               this.simulationStockForm.get('duree')?.valid &&
               this.simulationStockForm.get('valeurStock')?.valid &&
               this.simulationStockForm.get('typeMarchandises')?.valid;
      
      case 2: // Informations de l'entreprise
        return this.simulationStockForm.get('nom')?.valid && 
               this.simulationStockForm.get('dateNaiss')?.valid &&
               this.simulationStockForm.get('sexe')?.valid;
      
      default:
        return true;
    }
  }

  markFormGroupTouched() {
    Object.keys(this.simulationStockForm.controls).forEach(key => {
      const control = this.simulationStockForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }

  // Gestion des dates
  updateMinDates() {
    const dateEffet = this.simulationStockForm.get('dateEffet')?.value;
    if (dateEffet) {
      this.minDateEffet = new Date(dateEffet);
    }
  }

  // Gestion du téléphone
  hasError(event: any, field: string, form: string) {
    this.hasPhoneError = !event;
  }

  getNumber(number: string, field: string, form: string) {
    this.simulationStockForm.get(field)?.setValue(number);
  }

  telInputObject(obj: any) {
    // Gestion de l'objet téléphone
  }

  onCountryChange(country: any) {
    // Gestion du changement de pays pour le téléphone
  }

  // Gestion des fichiers
  selectOnFile(evt: any, type?: string, name?: string) {
    this.nomFile = name || 'Fichier sélectionné';
    this.loader = true;
    
    const accept = ['.doc', '.DOC', '.docx', '.DOCX', '.docm', '.DOCM', '.pdf', '.PDF', 
                   '.xls', '.XLS', '.xlsx', '.XLSX', '.png', '.PNG', '.jpg', '.JPG', '.jpeg', '.JPEG'];
    
    for (const file of evt.target.files) {  
      const index = file.name.lastIndexOf(".");
      const strsubstring = file.name.substring(index, file.name.length);
      let ext = strsubstring;
      
      if (accept.indexOf(strsubstring) === -1) {
        this.loader = false;
        this.toastr.error(`Ce fichier ${file.name} n'est pas au format autorisé`, 'Erreur');
        evt.target.value = '';
        return;
      } else {
        this.loader = true;
        const reader = new FileReader();
        
        reader.onload = (e: any) => {
          const docBase64Path = e.target.result;
          let image = '';
          
          if (ext === '.doc' || ext === '.DOC' || ext === '.docx' || ext === '.DOCX' || ext === '.docm' || ext === '.DOCM') {
            image = 'assets/images/doc.png';
            this.noImage = 'assets/images/doc.png';
          }
          else if (ext === '.pdf' || ext === '.PDF') {
            image = 'assets/images/pdf.png';
            this.noImage = 'assets/images/pdf.png';
          }
          else if (ext === '.xlsx' || ext === '.XLSX' || ext === '.xls' || ext === '.XLS') {
            image = 'assets/images/excel.png';
            this.noImage = 'assets/images/excel.png';
          }
          else {
            image = docBase64Path;
            this.noImage = docBase64Path;
          }
          this.saveFile1(file);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  saveFile1(file: File) {
    this.loader = true;
    let dataFile = new FormData();
    dataFile.append('files', file);
    
    this.rechercheService.saveFile(dataFile).subscribe(
      resp => {
        if (resp) {
          this.loader = false;
          this.toastr.success("Fichier chargé avec succès", 'Succès');
          this.pieceJointe.get('file')?.setValue(resp['urlprod']);
        }
      }, 
      error => {
        this.loader = false;
        this.noImage = "assets/images/upload.png";
        this.nomFile = "";
        const errorMessage = error?.error?.errors?.[0]?.message || 
                            error?.error?.message || 
                            "Erreur lors du chargement du fichier";
        
        this.toastr.error(errorMessage, 'Erreur');
        this.pieceJointe.get('file')?.setValue('');
      }
    );
  }

  downloadModel() {
    if (this.typeProduitList?.questionnaireUrl) {
      window.open(this.typeProduitList.questionnaireUrl, '_blank');
    } else {
      window.open('/assets/fileDownload/questionnaire_default.pdf', '_blank');
    }
    this.downloadFile = false;
  }

  // Sauvegarde
  saveData() {
    this.sendingRequest = true;
    this.loader = true;
    
    const finalData = {
      ...this.simulationStockForm.value,
      pieceJointe: this.pieceJointe.value,
      numeroSous: this.numeroSous,
      refPro: this.refPro
    };

    const submissionData = {
      designationClient: finalData.nom,
      telephone: finalData.telephone,
      email: finalData.email,
      typeRisque: "STOCK_MARCHANDISES",
      content: JSON.stringify(finalData)
    };
    
    this.rechercheService.saveSouscriptionOffline(submissionData)
      .subscribe(response => {
        if (response['responseCode'] == 200) {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.success("Demande de souscription enregistrée avec succès");
          this.currentStep = 4; // Étape succès
        } else {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.error(response['cause'].erreurs[0].message);
        }
      }, errors => {
        this.sendingRequest = false;
        this.loader = false;
        const errorMessage = errors['error']['cause'].erreurs ? 
          errors['error']['cause'].erreurs[0].message : 
          errors['error']['cause']['message'];
        this.toastr.error(errorMessage);
      });
  }

  resetForm() {
    this.currentStep = 0;
    this.simulationStockForm.reset();
    this.pieceJointe.reset();
    this.nomFile = "";
    this.noImage = "assets/images/upload.png";
    window.scrollTo(0, 0);
  }

  getProgressPercentage(): number {
    const progressSteps = {
      0: 0,   // Page d'accueil
      1: 33,  // Étape 1 sur 3
      2: 66,  // Étape 2 sur 3
      3: 100  // Récapitulatif
    };
    
    return progressSteps[this.currentStep] || 0;
  }

  getProgressText(): string {
    const progressTexts = {
      0: 'Bienvenue...',
      1: 'Informations sur le stock...',
      2: 'Informations de l\'entreprise...',
      3: 'Finalisation...'
    };
    
    return progressTexts[this.currentStep] || 'Chargement en cours...';
  }
  

  // ===== CONFIGURATION DE L'AUTOSAVE =====
  private setupAutoSave() {
    this.autoSaveSubscription = this.autoSaveSubject$.pipe(
      debounceTime(1000),
      distinctUntilChanged((prev, curr) => {
        return prev.email === curr.email && prev.telephone === curr.telephone;
      }),
      switchMap(data => {
        const currentDataString = JSON.stringify({
          email: data.email,
          telephone: data.telephone
        });
        
        if (currentDataString === this.lastSavedData) {
          return of(null);
        }
        
        this.lastSavedData = currentDataString;
        
        return this.rechercheService.autoSave(data).pipe(
          catchError(error => {
            return of(null);
          })
        );
      })
    ).subscribe(response => {
    });
  }

  // ===== MÉTHODE AUTOSAVE AMÉLIORÉE =====
  autoSave() {
    const formValue = this.simulationStockForm?.value;
    if (!formValue) return;

    const hasValidEmail = formValue.email && this.emailPattern.test(formValue.email);
    
    const hasValidPhone = formValue.telephone && formValue.telephone.trim().length >= 8;

    if (!hasValidEmail && !hasValidPhone) {
      return;
    }

    if (!this.currentFiliale?.id) {
      return;
    }

    const data = {
            "telephone": formValue.telephone?.trim(),
            "email": formValue.email?.trim().toLowerCase(),
            "adresse": formValue.adresse,
            "type": "ASSURANCE STOCK DE MARCHANDISES",
            "displayName": `${formValue.nom}`,
            "filiale": this.currentFiliale?.id,
            'prenom': formValue.prenom,
            'nom': formValue.nom,
    };

    this.autoSaveSubject$.next(data);
  }
  // ========================================


   getDevisAutre() {
        this.currentStep = 0;
        setTimeout(() => {
            window.scrollTo({
                top: 600,
                behavior: 'smooth'
            });
        }, 100);
  }

}